<template>
  <div>
    <el-tabs v-model="activeName" class="text-left mt-4">
      <el-tab-pane :label="$t('商品详情')" name="first"
        ><product-detail :data="item.detail"></product-detail
      ></el-tab-pane>
      <el-tab-pane :label="$t('用户评价')" name="second" v-if="false"
        ><product-comment
          :data="commentArr"
          :total="commentTotal"
          @changePage="changePage"
        ></product-comment
      ></el-tab-pane>
      <!-- <el-tab-pane :label="$t('常见问题')" name="third"
        >常见问题常见问题</el-tab-pane
      > -->
    </el-tabs>
  </div>
</template>

<script >
import { ref, onMounted } from "@vue/composition-api";
import ProductDetail from "@/components/product/productDetail.vue";
import ProductComment from "@/components/product/productComment.vue";

export default {
  props: {
    pid: Number,
    item: Object,
  },
  components: { ProductDetail, ProductComment },
  setup(props, ctx) {
    const activeName = ref("first");

    //获取评论
    const commentArr = ref([]);
    const commentTotal = ref();
    const getProductComment = async (page) => {
      const res = await ctx.root.$callapi("getProductComment", {
        page: page,
        size: 6,
        pid: props.pid,
      });
      commentArr.value = res.data.items;
      commentTotal.value = res.data.total;
    };
    onMounted(async () => {
      getProductComment(1);
    });
    //下一页
    const changePage = async (page) => {
      getProductComment(page);
    };
    return { activeName, commentArr, commentTotal, changePage };
  },
};
</script>

<style scoped lang="scss"></style>
